module.exports = __webpack_public_path__ + "static/media/file-view-base.e4f51c1d.svg";